import { useAuth } from 'hooks/AuthProvider'
import MaintenanceUnauthorized from 'pages/maintenance/401'

export const ProtectedRoute = ({ children, roles }: any) => {
  const { user } = useAuth()

  if (roles.includes(user?.userRoles?.map((role) => role.name).join(', ') || '')) {
    return <>{children}</>
  }

  return <MaintenanceUnauthorized />
}
